import { WellKnownRouter } from "@infrastructure/config/router";
import { RedirectToRouteType } from "@proxy/RedirectToRouteType";

export default class DynamicRedirect {
    public static getRedirectRoute(route) {
        const { params } = route;

        if (params) {
            let actionType = parseInt(params.actionType);
            switch (actionType) {
                case RedirectToRouteType.AppointmentDetails:
                    return {
                        name: WellKnownRouter.AppointmentDetails,
                        params: { appointmentId: params.actionId }
                    };
                case RedirectToRouteType.NonAppointmentDetails:
                    return {
                        name: WellKnownRouter.NonAppointmentDetails,
                        params: { nonAppointmentId: params.actionId }
                    };
                case RedirectToRouteType.ProvideAvailability:
                    return { name: WellKnownRouter.Availability };
                case RedirectToRouteType.AppointmentReport:
                    return {
                        name: WellKnownRouter.AppointmentReport,
                        params: { appointmentId: params.actionId }
                    };
                case RedirectToRouteType.NonAppointmentReport:
                    return {
                        name: WellKnownRouter.NonAppointmentReport,
                        params: { nonAppointmentId: params.actionId }
                    };
                case RedirectToRouteType.AvailabilityReminder:
                    return { name: WellKnownRouter.Availability };
                case RedirectToRouteType.FinanceRemittanceAdvice:
                    return { name: WellKnownRouter.RemittanceAdvice };
                case RedirectToRouteType.ResourcePage:
                    return {
                        name: WellKnownRouter.ResourcePageDetails,
                        params: { resourcePageId: params.actionId }
                    };
                case RedirectToRouteType.ProfessionalAccreditationProfile:
                    return { name: WellKnownRouter.ProviderAccreditations };
                case RedirectToRouteType.KeyDocuments:
                    return {
                        name: WellKnownRouter.KeyDocuments
                    };
                case RedirectToRouteType.PublicInformationProfile:
                    return { name: WellKnownRouter.PublicInformation };
                case RedirectToRouteType.ProfessionalServicesProfile:
                    return { name: WellKnownRouter.ProfessionalServices };
                case RedirectToRouteType.ProfessionalDetailsProfile:
                    return { name: WellKnownRouter.ProfessionalDetails };
                case RedirectToRouteType.PersonalDetailsProfile:
                    return { name: WellKnownRouter.PersonalDetails };

            }
        }

        return {
            name: WellKnownRouter.Error, params: { errorCode: 404 }
        };
    }
}
